import { FC } from 'react';
import { useSelector } from 'react-redux';
import { lazy } from 'utils/generic/lazy';
import { EAdvancedSelectedTabs } from 'interfaces/bet-data';
import { ProfitBoostManagerSliceMultiple } from 'newelements/_Betslip/managers/ProfitBoostManager/BetTypeBaseSlice/multiple';
import { getAdvancedSelectedTab, getAllBetIds } from 'store/selectors/betslip';

const { ProfitBoostManagerSliceSingle } = lazy(
  () =>
    import(
      /* webpackChunkName: "ProfitBoostManagerSliceSingle" */ 'newelements/_Betslip/managers/ProfitBoostManager/BetTypeBaseSlice/single'
    )
);

export const ProfitBoostBetslipTypeSliceAdvanced: FC = () => {
  const selectedTab = useSelector(getAdvancedSelectedTab);
  const allBetsCount = useSelector(getAllBetIds).length;

  return (
    <>
      {(selectedTab === EAdvancedSelectedTabs.MULTIPLES ||
        allBetsCount === 1) && <ProfitBoostManagerSliceSingle />}
      <ProfitBoostManagerSliceMultiple />
    </>
  );
};
